import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {
    getMedicamentosSubstitutos(context, idMedicamento) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("medicamentosSubstitutos/access/listarSubstitutos", {ID_DML_MEDICAMENTO: idMedicamento}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    salvaMedicamentosSubstitutos(context, dados) {
        return new Promise(resolve => {
            if(JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("medicamentosSubstitutos/access/salvarSubstitutos", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }
    
};

export default {
    state,
    actions,
    mutations,
    getters
};